import { useEffect } from 'react';
import { RouteEnum } from './routes';
import { useAuth } from '../providers/AuthProvider';
import { partnerAwareUrl } from '../services/branding/partnerSlugStorage';

export default function AuthMiddleware({ children }) {
  const { isLoggedIn } = useAuth();

  useEffect(() => {
    !isLoggedIn && window.location.replace(partnerAwareUrl(RouteEnum.Login));
  }, [isLoggedIn]);

  return isLoggedIn ? children : null;
}
